import http from '../../../service/axios';

export const pickupAPI = {
  search: async (q?: string) =>
    await http.get('/branch/search', {
      params: {
        q,
      },
    }),
};
